import React from "react";
import "./Contact.scss";
import contactphoto from "../../assets/images/Premium_Photo___Shopping_online_on_website_or_mobile_application_concept_marketing-removebg-preview.png";
import whatsapp from "../../assets/images/Icon awesome-whatsapp.png";
import call from "../../assets/images/Icon ionic-ios-call.png";
import chat from "../../assets/images/Icon ionic-md-chatboxes.png";
import { ImWhatsapp } from "react-icons/im";
import { AiOutlineMessage } from "react-icons/ai";
import { IoIosCall } from "react-icons/io";
import { RiDonutChartLine } from "react-icons/ri";
import { MdOutlineAlternateEmail } from "react-icons/md";
const Contact = () => {
  return (
    <div
      className="modal fade"
      id="ModalContact"
      tabIndex="-1"
      aria-labelledby="ContactLabel"
      aria-hidden="true"
    >
      <div
        className="modal-dialog
        modal-lg "
      >
        <div
          className="modal-content contactModal"
          style={{ borderRadius: "15px" }}
        >
          <div className="p-3">
            <button
              style={{ backgroundColor: "white " }}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>

          <div className="modal-body row">
            <div className="info-call col-12 col-sm-6">
              <div className="info-txt">باما درتماس باشید </div>
              <br />
              <br />
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div>
                  <div
                    className="items"
                    style={{ textAlign: "right", marginRight: "14px" }}
                  >
                    <div
                    // style={{
                    //   borderRadius: "50%",
                    //   border: "1px solid black",
                    //   height: "7px",
                    // }}
                    >
                      <IoIosCall></IoIosCall>
                    </div>
                  </div>
                  <div className="items">
                    <ImWhatsapp></ImWhatsapp>{" "}
                  </div>
                  <div className="items">
                    <AiOutlineMessage></AiOutlineMessage>{" "}
                  </div>
                  <div className="items">
                    <MdOutlineAlternateEmail></MdOutlineAlternateEmail>
                  </div>
                </div>
                <div>
                  <div className="items">
                    <a href={`tell:+98017_3344567`}>017_3344567</a>
                  </div>
                  <div className="items">
                    <a href={`tell:+9809220431417`}>09220431417</a>
                  </div>
                  <div className="items">
                    <div>چت آنلاین</div>
                  </div>
                  <div className="items">
                    <div> support@sabadi.ir</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 contactphoto">
              <img src={contactphoto} alt="contact" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Contact;
